import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/home";
import ErrorPage from "./pages/404";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
